<i
  class="ri-edit-2-fill cursor-pointer"
  type="button"
  (click)="openModal()"
  i18n-tooltip="@@customize"
  tooltip="Anpassen"
  placement="top"
  container="body"
></i>